/* =========================================================================
   Thoson: color del trazo de pincel bajo las palabras resaltadas. v17.11
   Lo carga sections/thx-header.liquid en todas las paginas (ver
   thx-headlines.css).

   Cada resaltado lleva el trazo en su color, con la opacidad que tenia en
   su seccion: hero del index 0.42, .thx-title 0.38, imagen + texto 0.4.
   El SVG del trazo se guarda en --thx-brush del propio <strong>.

   De paso, los espacios que quedaron dentro del <strong> en algunas
   plantillas ("<strong> Parents") se pasan fuera, para que el trazo no
   subraye un hueco.
   ========================================================================= */
(function () {
  if (window.thxBrush) return;
  window.thxBrush = true;

  var PATH = 'M3 9C62 2.6 112 3.6 160 6.8c48 3.2 92-2.8 137-0.8';
  var KINDS = [
    ['.thx-hero__title strong', 0.42],
    ['.thx-title strong', 0.38],
    ['.image-with-text--no-overlap .image-with-text__heading strong', 0.4]
  ];
  var cache = {};

  function svgFor(color, opacity) {
    var key = color + '|' + opacity;
    if (!cache[key]) {
      var svg = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 12' preserveAspectRatio='none'>" +
        "<path d='" + PATH + "' fill='none' stroke='" + color + "' stroke-opacity='" + opacity +
        "' stroke-width='5.5' stroke-linecap='round'/></svg>";
      cache[key] = 'url("data:image/svg+xml,' + encodeURIComponent(svg).replace(/'/g, '%27') + '")';
    }
    return cache[key];
  }

  function trim(s) {
    var a = s.firstChild, z = s.lastChild;
    if (a && a.nodeType === 3 && /^\s/.test(a.nodeValue)) {
      a.nodeValue = a.nodeValue.replace(/^\s+/, '');
      s.parentNode.insertBefore(document.createTextNode(' '), s);
    }
    if (z && z.nodeType === 3 && /\s$/.test(z.nodeValue)) {
      z.nodeValue = z.nodeValue.replace(/\s+$/, '');
      s.parentNode.insertBefore(document.createTextNode(' '), s.nextSibling);
    }
  }

  function paint(root) {
    root = root && root.querySelectorAll ? root : document;
    for (var k = 0; k < KINDS.length; k++) {
      var list = root.querySelectorAll(KINDS[k][0]);
      for (var i = 0; i < list.length; i++) {
        var s = list[i];
        if (s.getAttribute('data-thx-brush')) continue;
        trim(s);
        var color = getComputedStyle(s).color.replace(/\s+/g, '');
        s.style.setProperty('--thx-brush', svgFor(color, KINDS[k][1]));
        s.setAttribute('data-thx-brush', '1');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paint(); });
  } else {
    paint();
  }
  document.addEventListener('shopify:section:load', function (e) { paint(e.target); });
})();
